import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideCustomCVA } from '../../basics/ui-custom-cva.provider';
import { UiControlValueAccessorDirective } from '../../basics/ui-control-value-accessor';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { VerticalConnectionPos } from '@angular/cdk/overlay';
import { UI_LANGUAGES } from '../../basics/ui-language.provider';
import { BoschUiButtonComponent } from '../../atoms/bosch-ui-button/bosch-ui-button.component';
import { BoschUiButtonTypeEnum } from '../../atoms/bosch-ui-button/bosch-ui-button.model';
import { BoschUiIconComponent } from '../../atoms/bosch-ui-icon/bosch-ui-icon.component';
import { BoschUiIconNames } from '../../atoms/bosch-ui-icon/bosch-ui-icon.constants';
import { BoschUiShowOnScreenDirective } from '../../directives/bosch-ui-show-on-screen/bosch-ui-show-on-screen.directive';
import { BoschUiDropdownDesktopComponent } from '../../basics/bosch-ui-dropdown/bosch-ui-dropdown-desktop/bosch-ui-dropdown-desktop.component';
import { BoschUiDropdownMobileComponent } from '../../basics/bosch-ui-dropdown/bosch-ui-dropdown-mobile/bosch-ui-dropdown-mobile.component';

@Component({
  selector: 'bosch-ui-language-select',
  standalone: true,
  imports: [
    CommonModule,
    BoschUiButtonComponent,
    BoschUiIconComponent,
    BoschUiShowOnScreenDirective,
    BoschUiDropdownDesktopComponent,
    BoschUiDropdownMobileComponent,
    TranslateModule,
  ],
  templateUrl: './bosch-ui-language-select.component.html',
  styleUrls: ['./bosch-ui-language-select.component.scss'],
  providers: [provideCustomCVA(BoschUiLanguageSelectComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiLanguageSelectComponent extends UiControlValueAccessorDirective<string | null> implements OnInit {
  iconNames = BoschUiIconNames;
  buttonType = BoschUiButtonTypeEnum;
  isOpen$ = new BehaviorSubject(false);
  dropdownPosition$ = new BehaviorSubject<VerticalConnectionPos | null>(null);

  constructor(@Inject(UI_LANGUAGES) public languages: string[], private cdRef: ChangeDetectorRef) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.control.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value: string | null) => {
      this._value$.next(value);
      this.onChange(value);
    });
  }

  override writeValue(value: string | null): void {
    this.control.setValue(value);
  }

  onDropdownChange(isOpen: boolean): void {
    this.isOpen$.next(isOpen);
  }

  onDropdownPositionChange(position: VerticalConnectionPos): void {
    this.dropdownPosition$.next(position);
    this.cdRef.detectChanges();
  }

  onOptionClick(option: string): void {
    this.control.setValue(option);
    this.isOpen$.next(false);
  }

  onClose(): void {
    this.isOpen$.next(false);
  }
}
